import { UserColumns } from './UserColumns';

export const UserListColums = [
  UserColumns.id,
  UserColumns.name,
  UserColumns.documentalUserCode,
  UserColumns.role
];
